module.exports = __webpack_public_path__ + "static/media/TruckSunsetCaption_contact.aad2ed15.png";